// src/pages/MentorProfilePage.js
import React, { useEffect, useState } from 'react';

import MentorProfilePageBase from './MentorProfilePage.base';
import MentorProfilePageGreentech from './MentorProfilePage.greentech';

const GREENTECH_SURVEY_ID = 28;
const GREENTECH_TENANT_ID = 12;

export default function MentorProfilePage(props) {
  const [useGreentech, setUseGreentech] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch('/mentoring/mentor/profile', { credentials: 'include' });
        if (!res.ok) {
          if (!cancelled) setUseGreentech(false);
          return;
        }
        const data = await res.json();

        const isGreentech =
          Number(data?.tenant_id) === GREENTECH_TENANT_ID &&
          Number(data?.survey_id) === GREENTECH_SURVEY_ID;

        if (!cancelled) setUseGreentech(isGreentech);
      } catch {
        if (!cancelled) setUseGreentech(false);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!loaded) {
    return <div style={{ minHeight: '100vh' }} />;
  }

  const Page = useGreentech ? MentorProfilePageGreentech : MentorProfilePageBase;
  return <Page {...props} />;
}
